import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ApiService } from "src/app/services/api.service";
import { MatDialog } from '@angular/material/dialog';
import { AddDialogComponent } from'../../clients/add-dialog/add-dialog.component';
import { UpdateDialogComponent } from '../../clients/update-dialog/update-dialog.component';
import { DeleteDialogComponent } from '../../clients/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.less']
})
export class UsersComponent implements OnInit {

  items: { [id: string]: any[]; } = {};
  create: { [id: string]: any; } = {
    user: {},
};
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['name', 'email', 'phone', 'role', 'update', 'dalete'];
  pageSize = 10;
  loading: boolean;
  currentCompany: any = null
  currentCompanyId: string | null = null
  
  subscription: Subscription;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('input') searchInput: ElementRef;

  constructor(private dataService: DataService,
    private _api: ApiService,
    public dialog: MatDialog,) {
  }

  ngOnInit(): void {
    this.fetchData();
  }

  // ngOnDestroy() {
  //   this.subscription.unsubscribe();
  // }

  fetchData() {
    this.loading = true;
    this._api.get<any>(`/user/admin`).subscribe(resp => {
        this.loading = false;
        this.items['user'] = resp;
        if (resp.length === 0) {
            this.dataSource = new MatTableDataSource();
            return;
          };
        this.dataSource = new MatTableDataSource(resp.reverse());
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }, err => {
        alert(err.message);
    });

  }

    addNew(type: string){
      let title = type[0].toUpperCase() + type.slice(1)
      let data: any = {
          type: type,
          company: this.currentCompanyId,
          role: "sa",
          title: title,
          name: '',
          function: (item) => this.add(type, item)
        }

      
      
      const dialogRef = this.dialog.open(AddDialogComponent, {
          disableClose: true,
          data: data
          
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result === undefined) return;
          setTimeout(() => result.name);
          this.fetchData();
        });
  }

  add(type: string, data: any) {
      return this._api.post<any>(`/${type}`, data);
  }

  editUser(user){
    this.create['user'] = user
        const dialogRef = this.dialog.open(UpdateDialogComponent, {
          disableClose: true,
          data: {
            type: 'user',
            title: 'User',
            name: user.name,
            data: user,
            function: (user) => this.editName('user', user)
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result === undefined) return;
          setTimeout(() => user = result);
          this.create['user'] = {}
          this.fetchData();
        });
  }

  editName(type: string, name: any) {
    this.create[type] = name.data
    return this._api.put<any>(`/${type}/${this.create[type]._id}`, this.create[type]);
  }

  deleteUser(user){
    // Not allow to delete last Super User
    if (this.items?.user.length == 1)
    {
      return;
    }

    this.create['user'] = user
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      disableClose: true,
      data: {
        type: 'user',
        title: 'User',
        name: user.name,
        function: (user) => this.deleteOptions('user', user)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => user.name = result.name);
      this.create['user'] = {}
      this.fetchData();
    });
  }

  deleteOptions(type: string, name: any) {
    return this._api.delete(`/${type}/${this.create[type]._id}`)
    
}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();


    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
